import React from 'react';
import {useEvent, useSubEvent} from '../../data/hooks/eventHooks';
import {Redirect} from 'react-router';

function HasEvent(props) {
    const {eventId, children} = props,
        event = useEvent(eventId),
        [community, subEvent] = useSubEvent(eventId);

    if (event) {
        // event was found
        return children;
    } else if (community && subEvent) {
        // event not found, but it matches a community sub event
        console.log(`Given eventId ${eventId} matches community sub-event: redirecting.`);
        return <Redirect to={['/events', community.id, 'agenda', subEvent.agenda_type ? 'item' : 'subevent', subEvent.id].join('/')} />;
    } else {
        // error handling: event was not found
        console.warn(`Invalid event or not found. Redirecting to root.`);
        return <Redirect to="/" />;
    }
}

export default HasEvent;
